import { render, staticRenderFns } from "./PageThreeElite.vue?vue&type=template&id=227ea3b6&scoped=true"
import script from "./PageThreeElite.vue?vue&type=script&lang=js"
export * from "./PageThreeElite.vue?vue&type=script&lang=js"
import style0 from "./PageThreeElite.vue?vue&type=style&index=0&id=227ea3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ea3b6",
  null
  
)

export default component.exports